import { render, staticRenderFns } from "./object-lister.vue?vue&type=template&id=a6d69bc4&scoped=true"
import script from "./object-lister.vue?vue&type=script&lang=js"
export * from "./object-lister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d69bc4",
  null
  
)

export default component.exports